var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function XCloseIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7071 5.70761C20.0976 5.31709 20.0976 4.68392 19.7071 4.29339C19.3166 3.90286 18.6834 3.90285 18.2929 4.29337L12 10.5861L5.70709 4.29337C5.31656 3.90285 4.6834 3.90286 4.29288 4.29339C3.90236 4.68392 3.90237 5.31709 4.29291 5.70761L10.5858 12.0002L4.29291 18.2929C3.90237 18.6834 3.90236 19.3166 4.29288 19.7071C4.6834 20.0976 5.31656 20.0976 5.70709 19.7071L12 13.4144L18.2929 19.7071C18.6834 20.0976 19.3166 20.0976 19.7071 19.7071C20.0976 19.3166 20.0976 18.6834 19.7071 18.2929L13.4142 12.0002L19.7071 5.70761Z",
    fill: ""
  }));
}
export var XCloseIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: XCloseIconInner
  }, props));
};